"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
import SimpleBar from "simplebar";

window.addEventListener("DOMContentLoaded", () => {});

/******************
 * パララックス表現
 ******************/
ScrollTrigger.create({
  trigger: ".future-vision__icon",
  start: "top -60px",
  endTrigger: ".future-vision",
  end: `bottom 100%`,
  pin: true,
  pinSpacing: false,
});
